import { render, staticRenderFns } from "./MyData.vue?vue&type=template&id=f556d832&scoped=true&"
import script from "./MyData.vue?vue&type=script&lang=js&"
export * from "./MyData.vue?vue&type=script&lang=js&"
import style0 from "./MyData.vue?vue&type=style&index=0&id=f556d832&lang=scss&scoped=true&"
import style1 from "./MyData.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f556d832",
  null
  
)

export default component.exports